import { paymentMethodsConstants } from './index';

export const MULTI_CURRENCY_PAYMENT_TYPES = [
  paymentMethodsConstants.CARD,
  paymentMethodsConstants.APPLE_PAY,
  paymentMethodsConstants.GOOGLE_PAY,
] as const;

export function supportsMultiCurrencyDisplay(
  paymentMethodType?: string | null
): boolean {
  if (!paymentMethodType) {
    return true;
  }

  return MULTI_CURRENCY_PAYMENT_TYPES.includes(
    paymentMethodType.toLowerCase() as (typeof MULTI_CURRENCY_PAYMENT_TYPES)[number]
  );
}
